import { render, staticRenderFns } from "./CallTIM.vue?vue&type=template&id=6744f136&scoped=true"
import script from "./CallTIM.vue?vue&type=script&lang=js"
export * from "./CallTIM.vue?vue&type=script&lang=js"
import style0 from "./CallTIM.vue?vue&type=style&index=0&id=6744f136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6744f136",
  null
  
)

export default component.exports